module.exports = __webpack_public_path__ + "static/ashwin-c26803275905c153597cd698553d4fd0.png";